import { AxiosFactory } from '../utils';

export interface Business {
  name: string,
  addresses: Address[],
  signer: Contact,
}

export interface Contact {
  ownership?: number,
  ssn?: string,
}

export interface Address {
  addressLine1: string,
  addressLine2?: string,
  city?: string,
  state?: string,
  stateCode?: string,
  postCode?: string,
  country?: string,
  countryCode?: string,
  isPrimary: boolean,
}

export const getBusiness = async (): Promise<Business> => {
  const response = await AxiosFactory.axiosInstance().get<Business>('/merchantGraph/contact');
  return response.data;
};

export const updateBusiness = async (business: Business): Promise<void> => {
  await AxiosFactory.axiosInstance().post<void>('/merchantGraph/contact', business);
};
